import event from '@drivesally/sally-fw/lib/event/event';

export default event('/driver/selected');
